<template>
  <div
    class="profile-memo"
  >
    <DppTextarea
      v-model="localMemo"
      content-class="text-textLight"
      custom-label="When to use this template"
      placeholder="Add usage guidance"
      :readonly="!isEditing"
      :disabled="saving"
      :maxlength="120"
      auto-grow
      rounded="md"
      rows="2"
      variant="outlined"
      @click="canEdit && enterEditMode()"
      @keydown.esc="cancelEdit"
      @keydown.enter="applyEdit"
    />

    <div
      v-if="isEditing"
      class="d-flex ga-1 justify-space-between mt-1"
    >
      <div class="text-body-2 text-textLight my-auto">
        {{ localMemo.length }} / 120
      </div>

      <div class="d-flex ga-1">
        <v-btn
          size="small"
          variant="outlined"
          color="error"
          rounded="lg"
          @click="cancelEdit"
        >
          Cancel
        </v-btn>
        <v-btn
          size="small"
          variant="flat"
          color="primary"
          rounded="lg"
          @click="applyEdit"
        >
          Save
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useAppAuthData } from '@/stores/app/authData';
import DppTextarea from '@/components/datapeople/DpplTextArea.vue';

const { jobProfile } = storeToRefs(useCurrentJobProfile());
const { updateMemo } = useCurrentJobProfile();
const { checkRbacPermissions } = useAppAuthData();

const canEdit = computed(() => checkRbacPermissions(['createProfileTemplate']));

const isEditing = ref(false);
const saving = ref(false);
const localMemo = ref(jobProfile.value.memo ?? '');

const enterEditMode = () => {
  isEditing.value = true;
};

const cancelEdit = () => {
  isEditing.value = false;
  localMemo.value = jobProfile.value.memo ?? '';
};

const applyEdit = async () => {
  saving.value = true;
  try {
    await updateMemo(localMemo.value);
    isEditing.value = false;
  } finally {
    saving.value = false;
  }
};
</script>

<style lang="less" scoped>
.profile-memo {
  &:deep(.form-label-text) {
    color: rgb(var(--v-theme-textLight));
  }
}
</style>
